// Mock-Data-Detection Utility
import { ExploreElement } from '../models/ExploreElementModel/ExploreElementModel';

/**
 * Detektiert, ob ein ExploreElement aus Mock-Daten erstellt wurde
 * @param element Das zu prüfende ExploreElement
 * @returns true wenn es sich um Mock-Daten handelt, false andernfalls
 */
export const isMockElement = (element: ExploreElement): boolean => {
  if (!element || !element.id) {
    return false;
  }

  // Mock-Daten haben spezifische ID-Präfixe
  const mockIdPrefixes = [
    'event_',
    'person_',
    'ranking_',
    'ranking-', // Mit Bindestrich (für neue Mock-Daten)
    'agent_',
    'contest_',
    'mock_person_', // Für generierte Mock-Personen
    'mock_',
    'ai_', // AI-Agents
    'contest-', // Contests mit Bindestrich
  ];

  return mockIdPrefixes.some((prefix) => element.id.startsWith(prefix));
};